<script setup lang="ts">
import { AppMultiSelectSearchable } from '@shared/ui/selects'

import { useLessonFilterTutors } from '../../model/lessons/lesson-filter-tutors.hook'

defineOptions({
  name: 'LessonFilterTutors',
})

withDefaults(defineProps<{
  disabled?: boolean
}>(), {
  disabled: false,
})

const model = defineModel<number[]>({ default: () => [] })

const {
  refSelectedIds,
  tutorOptions,
  selectedTutorOptions,
  tutorHasMore,
  tutorLoading,
  onTutorSearch,
  onTutorLoadMore,
  onTutorOpen,
} = useLessonFilterTutors({ selectedIds: model })
</script>

<template>
  <AppMultiSelectSearchable
    v-model="refSelectedIds"
    :options="tutorOptions"
    :selected-options="selectedTutorOptions"
    :has-more="tutorHasMore"
    :loading="tutorLoading"
    label="Tutors"
    placeholder="All"
    :disabled="disabled"
    clearable
    infinite
    @search="onTutorSearch"
    @load-more="onTutorLoadMore"
    @open="onTutorOpen"
  />
</template>
